<template>
  	<div class="row">
		<SideMenu/>
		<div class="right-column">
			<TopBar/>
			<main class="main-content p-5" role="main">
				<div class="row">
					<div class="col-md-12">
						<h1> {{title}} </h1>
					</div>
				</div>

				<div v-if="auth || verified" class="card">
					<div class="card-body">											                 
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-4 col-12 pb-3">									
									<!-- <div class="input-group">
										<div class="input-group-prepend">
											<div class="input-group-text"><i class="fa fa-bell-o" aria-hidden="true"></i></div>
										</div>
										<input type="text" class="form-control" placeholder="Buscar por folio..." v-model="searchModel">
									</div>																											 -->
								</div>
								<div class="col-md-8 col-12 pb-3">
									<div class="float-right">									
										<div class="btn-group">
											<button type="button" class="btn btn-secondary btn-sm" style="height: 33.84px;" @click="create()">Agregar<i class="fa fa-plus" aria-hidden="true" style="margin-left: 5px"></i></button>
											<button type="button" class="btn btn-secondary btn-sm" @click="updateItems()">Actualizar<i class="fa fa-refresh" aria-hidden="true" style="margin-left: 5px"></i></button>
											<!-- <button type="button" class="btn btn-secondary btn-sm"><i class="fa fa-sliders" aria-hidden="true"></i></button>										 -->
										</div>		
									</div>
								</div>																																
							</div>
						</div>																												
						<div class="col-md-12 mb-3">					
							<table class="table">
								<thead>
									<tr>
										<th>#</th>
										<th> Folio </th>
										<th> Estatus </th>
										<th> Consumo </th>
										<th> Opciones </th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, index) in items" v-bind:key="row.alimentoId" >
										<td>{{index+1}}</td>
										<td class="text-capitalize">{{row.folio}}</td>
										<td class="text-capitalize">{{row.status}}</td>
										<td class="text-capitalize">{{row.consumo}}</td>
										<td>
											<div class="cont">
												<button type="button" class="btn btn-danger py-1 px-2 my-0 mx-2"  @click="delet(row.ordenId)"><i class="fa fa-trash"></i></button>
												<button type="button" class="btn btn-secondary py-1 px-2 my-0 mx-2"  @click="edit(row.ordenId)"><i class="fa fa-edit"></i></button>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-md-12">
							<div class="justify-content-center">
								<div class="d-flex justify-content-center">
									<button type="button" class="btn btn-secondary btn-sm" @click="back()"><i class="fa fa-angle-left"></i></button>
									<h5 class="mx-3 my-2">{{ page }}</h5>
									<button type="button" class="btn btn-secondary btn-sm" @click="next()"><i class="fa fa-angle-right"></i></button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-else class="card">
					<div class="card-header">
						Autenticación
					</div>
					<div class="card-body">
						<p class="pb-2">
							Por razones de seguridad, es necesario comprobar su identidad. A continuación ingrese la contraseña para consultar el
							Historial de Ordenes.
						</p>
						<div class="form-group row">
							<label for="inputEmail3" class="col-sm-2" style="line-height: 2.9;">Contraseña</label>
							<div class="col-sm-6">
								<input type="password" class="form-control my-0" id="inputEmail3" placeholder="Contraseña" v-model="pass">
							</div>
							<div class="col-sm-4">
								<button class="btn btn-danger float-right" @click="autenticarInicio" style="height: 36px;line-height: 1;width: 75%;">
									Ingresar
								</button>
							</div>
						</div>
					</div>
				</div>						
			</main>
		</div>
	</div>
</template>


<script>
import SideMenu from '@/components/SideMenu.vue';
import TopBar from '@/components/TopBar.vue';
import ResOrdenes from '@/modules/restaurant/models/ResOrdenes.js';
import Sucursal from "@/modules/restaurant/models/Sucursal.js";

// import Faker from 'faker';

export default {
  name: 'viewHistorialOrdenes',
  props: ['auth'],
  data() {
    return {
		title: "Historial de Ordenes",
		items:[],
		count: -1,
		debug: process.env.VUE_APP_DEV,
		searchModel: "",
		pass : "",
		verified : false,
		page: 1,
		sid: null
      };
  },
  components: {
	  SideMenu,
	  TopBar,
  },
  methods: {
	loadItems(res){
		console.log(res)
		this.items = res.data.items
	},
	edit(id){
		this.$router.push({ name: 'ResOrdenesEdit', params: { item: {ordenId : id, auth : true} } });
	},
	autenticarInicio(){
		if(this.sid == null){
			this.$toast.error('No se ha cargado el archivo de configuración');
			return;
		}

		var x;
		this.verified = Sucursal.verificarAutenticacion(this.pass)
		if(this.verified){
			x = this.$toast.success('Acceso Autorizado')
			this.updateItems()			
		}
		else{
			x = this.$toast.error('Contraseña incorrecta');
		}
		this.pass = ""
	},
	updateItems(){
		ResOrdenes.historialOrdenes(this.sid.idSucursal+'/'+this.page, this.loadItems )
	},
	create(){
		this.$router.push({ name: 'ResHerisOrdenesCreate' })
	},
	delet(id){
		let _this = this;
		ResOrdenes.delete(id, function(res){
			_this.$toast.success('Elemento Eliminado');
			_this.updateItems()
		});
	},
	back(){	
		if(this.page < 1){
			var x = this.$toast.error('No hay más ordenes');
			return;
		}
		this.page += -1
		this.updateItems()
	},
	next(){
		if(this.items.length == 0){
			var x = this.$toast.error('No hay más ordenes');
			return;
		}
		this.page += 1
		this.updateItems()
	}
  },
  computed:{
	  filteredItems : function() {
		let _this = this		  
		if(_this.searchModel.length==0){return _this.items}		  
		return _this.items.filter(function (item) {
		  return String(item.nombre).includes(_this.searchModel);
		})
	  }
  },
  mounted() {
	this.sid = Sucursal.getSucursal()
	if(this.auth){
		this.updateItems()
	}
  }
};
</script>

<style>

.btn.btn-secondary.btn-sm, .btn.btn-danger.btn-sm{
	margin: 0px;
}
</style>